import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { PortfolioCategorySectionSkeleton } from "web_myplann/Portfolio/Components/Redesign/PortfolioCategorySectionSkeleton";

export const PortfolioListSkeleton: FC = () => {
	const theme = useTheme();

	return (
		<Stack bgcolor={theme.palette.grey[50]} minHeight="100vh">
			<PortfolioCategorySectionSkeleton rows={4} />
			<PortfolioCategorySectionSkeleton rows={3} />
		</Stack>
	);
};
